import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../../../../../api/baseUrl";
import { addPrescription } from "../../../../../../redux/diagnosestate/diagnoseAction";
interface Diagnose {
  _id: string;
  diagnose: string;
}

interface FormData {
  drugsId: string;
  drugsIds: string;
  doseId: string;
  frequency: string;
  duration: string;
  drugs: string;
  dose: string;
  doseIds: string;
  type: string;
}

function PrescriptionForm() {
  const dispatch = useDispatch();
  const { ID } = useParams();
  const initialFormData: FormData = {
    drugsId: "",
    drugsIds: "",
    drugs: "",
    dose: "",
    doseId: "",
    doseIds: "",
    frequency: "",
    duration: "",
    type: "",
  };
  const [formData, setformData] = useState(initialFormData);

  const [data, setData] = useState([]);

  useEffect(() => {
    baseUrl
      .get("/client/prescription/prescription/findAllPrescription")
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to fetch diagnoses. Please try again.");
      });
  }, []);

  const diagnoseOptions = useMemo(
    () =>
      data.map((item: any) => (
        <option
          value={item._id + "/" + item.drugs + "/" + item.type}
          key={item._id}
        >
          {item.drugs}
        </option>
      )),
    [data]
  );
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (name === "drugsIds") {
      setformData((prev) => ({
        ...prev,
        [name]: value,
        drugsId: value.split("/")[0],
        drugs: value.split("/")[1],
        type: value.split("/")[2],
      }));
    } else if (name === "doseIds") {
      setformData((prev) => ({
        ...prev,
        [name]: value,
        doseId: value.split("/")[0],
        dose: value.split("/")[1],
      }));
    } else {
      setformData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      if (
        !formData.drugsId ||
        !formData.doseIds ||
        !formData.frequency ||
        !formData.duration
      ) {
        toast.error("Please select a drugs.");
        return;
      }
      const response = await baseUrl.patch(
        "/client/treatments/prescription/addprescription",
        formData,
        {
          headers: { treatmentid: ID },
        }
      );

      dispatch(
        addPrescription({
          ...formData,
          createdAt: response.data.data.createdAt,
          _id: response.data.data._id,
        })
      );
      setformData(initialFormData);
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit the form.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="form-control">
        <label htmlFor="">Drugs</label>
        <select
          name="drugsIds"
          value={formData.drugsIds}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          {diagnoseOptions}
        </select>
      </div>
      <div className="form-control">
        <label htmlFor="">Dose</label>
        <select
          name="doseIds"
          value={formData.doseIds}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          {data
            ?.filter((item: any) => item._id === formData.drugsId)
            ?.map((filteredItem: any) => filteredItem.dose)
            ?.flat()
            .map((item: any, i: number) => (
              <option key={i} value={item + "/" + item}>
                {item+""+formData.type}
              </option>
            ))}
        </select>
      </div>
      <div className="form-control">
        <label htmlFor="">Frequency</label>
        <select
          name="frequency"
          value={formData.frequency}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="bd">bd</option>
          <option value="tds">tds</option>
          <option value="qds">qds</option>
          <option value="nocte">nocte</option>
          <option value="sos">sos</option>
          <option value="stat">stat</option>
          <option value="stat , 100mg/nocte">stat , 100mg/nocte</option>
          <option value="mane">mane</option>
        </select>
      </div>
      <div className="form-control">
        <label htmlFor="">Duration</label>
        <select
          name="duration"
          value={formData.duration}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
        </select>
      </div>
      <button type="submit">ADD</button>
    </form>
  );
}

export default PrescriptionForm;
